export const FilterIcon = () => (
  <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_40_2061)">
      <path
        d="M13.9569 14.4L23 4.8V0H0.392212V4.8L9.43533 14.4V24L13.9569 19.2V14.4Z"
        fill="#F06D24"
      />
    </g>
    <defs>
      <clipPath id="clip0_40_2061">
        <rect width="22.6078" height="24" fill="white" transform="translate(0.392212)" />
      </clipPath>
    </defs>
  </svg>
);
